/* Utils */
import { generateEntityActionTypes } from '../utils/generators/actionTypeGenerators';

const ENTITY_NAME = 'SCHEDULES';

export const SCHEDULE_ENTITY_ACTION_TYPES = generateEntityActionTypes(ENTITY_NAME);
